import React from 'react';
import '../styles/specificinfo.css'; 

const SpecificItemInfo = ({ specificInfo, onClose }) => {
  return (
    <div className="specific-item-info-overlay">
      <div className="specific-item-info">
        <div className="info-header">
          <h2>Specific Item Info</h2>
          <button 
            onClick={onClose} 
            className="close-button"
            aria-label="Close"
          >
            ×
          </button>
        </div>

        <div className="info-content">
        {specificInfo && specificInfo.length > 0 ? (
            <table className="info-table">
              <tbody>
                {specificInfo.map((info, index) => (
                  <tr key={index}>
                    <td className="info-label"><strong>{info.label}:</strong></td>
                    <td className="info-value">{info.value}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p>No specific information available.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default SpecificItemInfo;